import { ReadOutlined } from "@ant-design/icons";
import { KnowledgeFile } from "@client/component/KnowledgeFile";
import { GameTypeConfigList } from "@client/config";
import { Color, Style } from "@client/style";
import { css, cx } from "@emotion/css";
import { IKnowledgePoint, SubNamespace } from "@share";
import { Button, Col, Collapse, Modal, Row } from "antd";
import React, { useState } from "react";
import { Md } from "./Modal";

export const KnowledgePointList: IKnowledgePoint[] = [
  {
    namespace: SubNamespace.Concept,
    title: "搜寻与数学期望",
    fileName: "1.1.pdf",
  },
  {
    namespace: SubNamespace.Concept,
    title: "搜寻中的不确定性和消费者的风险态度",
    fileName: "1.2.pdf",
  },
  {
    namespace: SubNamespace.Concept,
    title: "效用函数和搜寻的期望效用",
    fileName: "1.3.pdf",
  },
  {
    namespace: SubNamespace.Concept,
    title: "（确定性的）搜寻成本",
    fileName: "1.4.pdf",
  },
  {
    namespace: SubNamespace.Concept,
    title: "完美理性",
    fileName: "1.5.pdf",
  },
  {
    namespace: SubNamespace.RentHouse,
    title: "一个（随机）市场搜寻的例子",
    fileName: "2.1.pdf",
  },
  {
    namespace: SubNamespace.RentHouse,
    title: "（常数）保留效用",
    fileName: "2.2.pdf",
  },
  {
    namespace: SubNamespace.RentHouse,
    title: "搜寻规则的限制：不允许返回",
    fileName: "2.3.pdf",
  },
  {
    namespace: SubNamespace.FindJob,
    title: "（非常数的）保留效用",
    fileName: "2.4.pdf",
  },
  {
    namespace: SubNamespace.BuyCar,
    title: "限时优惠",
    fileName: "3.1.pdf",
  },
  {
    namespace: SubNamespace.BuyCar,
    title: "限时优惠是价格歧视么？",
    fileName: "3.2.pdf",
  },
  {
    namespace: SubNamespace.BuyTicket,
    title: "价格锁定",
    fileName: "3.3.pdf",
  },
  {
    namespace: SubNamespace.BuyTicket,
    title: "预付定金",
    fileName: "3.4.pdf",
  },
  {
    namespace: SubNamespace.BuyInsurance,
    title: "混淆和决策压力",
    fileName: "3.5.pdf",
  },
  {
    namespace: SubNamespace.BuyInsurance,
    title: "综合使用影响消费者搜寻的策略",
    fileName: "3.6.pdf",
  },
  {
    namespace: SubNamespace.SaleFurniture,
    title: "限时优惠下的需求和最优促销策略分析",
    fileName: "4.1.pdf",
  },
  {
    namespace: SubNamespace.SaleCar,
    title: "预付定金下的需求和最优销售策略分析",
    fileName: "4.2.pdf",
  },
  {
    namespace: SubNamespace.TradeCar,
    title: "卖家的市场竞争与限时优惠策略",
    fileName: "5.1.pdf",
  },
  {
    namespace: SubNamespace.Bargain,
    title: "一个开放的搜寻世界",
    fileName: "5.2.pdf",
  },
];

export function KnowledgePoints() {
  const [visible, setVisible] = useState(false);
  const [fileName, setFileName] = useState(KnowledgePointList[0].fileName);
  return (
    <>
      <Button className={Style.btnPrimarySm} icon={<ReadOutlined />} onClick={() => setVisible(true)}>
        知识点
      </Button>
      <Modal
        {...Md.pageProps}
        title={false}
        visible={visible}
        cancelButtonProps={{ hidden: true }}
        onOk={() => setVisible(false)}
      >
        <Row>
          <Col span={8}>
            <Collapse ghost accordion defaultActiveKey={GameTypeConfigList[0].label}>
              {GameTypeConfigList.map(({ subNamespaceList, label }, i) => (
                <Collapse.Panel header={label} key={label}>
                  <ul>
                    {subNamespaceList.map((namespace, j) => {
                      const res = [];
                      const knowledge = KnowledgePointList.filter((s) => s.namespace === namespace);
                      knowledge.forEach((k) => {
                        res.push(
                          <li
                            className={cx(
                              css`
                                font-size: 1.45rem;
                                margin-left: 2rem;
                                padding: 0.5rem 0;
                                list-style: decimal;
                                cursor: pointer;
                                transition: all 0.2s linear;
                                &:hover {
                                  color: ${Color.main};
                                }
                              `,
                              k.fileName === fileName
                                ? css`
                                    color: ${Color.main};
                                    text-decoration: underline;
                                  `
                                : null
                            )}
                            key={k.title}
                            onClick={() => setFileName(k.fileName)}
                          >
                            {k.title}
                          </li>
                        );
                      });
                      return res;
                    })}
                  </ul>
                </Collapse.Panel>
              ))}
            </Collapse>
          </Col>
          <Col
            span={16}
            className={css`
              height: 70vh;
            `}
          >
            {fileName && <KnowledgeFile fileName={fileName} />}
          </Col>
        </Row>
      </Modal>
    </>
  );
}
